// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"A_thecomp__QWPh3"};